import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader } from '@livable/saas-react-components';
import { Alert, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from '@mui/material';
// import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import { isNewSubmeterCycle, readCycleBill, refreshCycleBill } from './refreshCycleBill';
import BillDetails from './billDetails';
import { MeterDetails } from './MeterDetails';
import useStyles from './styles';
export const ApplyBillingFullContent = observer(_ref => {
  var _property$allocations, _utility$bill2, _utility$bill3, _utility$bill4, _utility$bill5;
  let handleClose = _ref.handleClose,
    _ref$property = _ref.property,
    property = _ref$property === void 0 ? {} : _ref$property;
  const classes = useStyles();
  const store = useStore();
  // const { t } = useTranslation();
  const page = 'Apply Billing';
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const applyBill = currentCompany.billingTab.applyBill || {};
  const billingCycleId = applyBill.billingCycleId;
  const propertyId = property.id;
  const showPreview = applyBill.status === 'PendingApproval' || applyBill.status === 'TableReady' || applyBill.status === 'TableReadyStatementSent';
  const utility = (_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.utilityById.get(billingCycleId + applyBill.utilityId);
  const utilityId = applyBill.utilityId;
  const isSkipped = applyBill.status === 'TableSkipped';
  // New Submeter was decided once, on Process (utility.jsx): flag on, utility set up for it, cycle with no
  // interim charges. Any other submeter cycle stays on the interim flow and gets the plain Bill details
  // view here. The flag is checked again so turning it off mid-session hides the tab.
  const isSubmeterUtility = isNewSubmeterCycle({
    store,
    applyBill,
    utility
  });
  const getAllocationComparison = async data => {
    const resp = await store.allocations.getAllocationComparisonAsync.run(data);
    return resp;
  };
  const handleMeterApproved = async () => {
    var _store$homeDashboardS;
    const billingTab = currentCompany.billingTab;
    const isOpenCycle = () => {
      var _billingTab$applyBill, _billingTab$applyBill2, _billingTab$applyBill3;
      return ((_billingTab$applyBill = billingTab.applyBill) === null || _billingTab$applyBill === void 0 ? void 0 : _billingTab$applyBill.propertyId) === propertyId && ((_billingTab$applyBill2 = billingTab.applyBill) === null || _billingTab$applyBill2 === void 0 ? void 0 : _billingTab$applyBill2.billingCycleId) === billingCycleId && ((_billingTab$applyBill3 = billingTab.applyBill) === null || _billingTab$applyBill3 === void 0 ? void 0 : _billingTab$applyBill3.utilityId) === utilityId;
    };
    await billingTab.updateBillingSummaryTimestamp();
    billingTab.addToPreviewQueue({
      billingCycleId,
      id: billingCycleId + propertyId,
      portfolioId: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '',
      propertyId
    });
    if (!isOpenCycle()) return;
    await refreshCycleBill({
      store,
      billingTab,
      allocations: property.allocations,
      propertyId,
      billingCycleId,
      utilityId,
      isSubmeterUtility
    });
  };
  const isOpen = currentCompany.billingTab.isApplyBillingIsOpen;
  /**
   * Whether this screen's own read of the cycle table has succeeded, or there was none to make. Until then the store may
   * not yet hold this cycle's saved bill, and a bill brought back meanwhile must not be taken for the only one (LB-6102).
   * This screen's read and not the store action's flag: the action is shared, and another read finishing says nothing
   * about this one.
   */
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    readKey = _useState2[0],
    setReadKey = _useState2[1];
  // A read that failed or was cancelled leaves the saved bill unknown: the form stays off until a retry lands.
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasReadFailed = _useState4[0],
    setHasReadFailed = _useState4[1];
  const _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    readAttempt = _useState6[0],
    setReadAttempt = _useState6[1];
  const openKey = "".concat(propertyId, "|").concat(billingCycleId, "|").concat(utilityId);
  const readScope = "".concat(openKey, "|").concat(applyBill.status, "|").concat(readAttempt);
  const hasReadTable = readKey === readScope;
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    formShownKey = _useState8[0],
    setFormShownKey = _useState8[1];
  const isFormShown = formShownKey === openKey;
  const isFormWithheld = !isFormShown && !hasReadTable;
  useEffect(() => {
    if (!isFormWithheld) setFormShownKey(openKey);
  }, [isFormWithheld, openKey]);
  useEffect(() => {
    if (!isOpen || !billingCycleId || !propertyId || !utilityId) {
      return;
    }
    let isCurrent = true;
    const markTableRead = isRead => {
      if (!isCurrent) return;
      if (isRead) setReadKey(readScope);else setHasReadFailed(true);
    };
    // The loader is shared by every read on the screen: a read only takes down its own, and not once a newer read has
    // replaced it, or a read cancelled by reopening would uncover the form while the new one is still out.
    let isLoading = false;
    const startLoading = () => {
      isLoading = true;
      currentCompany.billingTab.setIsModalLoading(true);
    };
    const stopLoading = () => {
      if (!isCurrent || !isLoading) return;
      isLoading = false;
      currentCompany.billingTab.setIsModalLoading(false);
    };
    setReadKey('');
    setHasReadFailed(false);

    // One table read: store actions cancel an in-flight call of the same action. Only a read that succeeded counts.
    const readTable = () => readCycleBill({
      store,
      billingTab: currentCompany.billingTab,
      allocations: property.allocations,
      propertyId,
      billingCycleId,
      utilityId,
      isSubmeterUtility
    }).then(_ref2 => {
      let isRead = _ref2.isRead;
      return isRead;
    }, () => false);
    const readComparison = () => getAllocationComparison({
      billingCycleId,
      propertyId,
      utilityId
    });
    if (showPreview || applyBill.status === 'PendingCompletion') {
      startLoading();
      const tableRead = showPreview || isSubmeterUtility ? readTable() : Promise.resolve(true);
      tableRead.then(markTableRead);
      tableRead.then(isRead => isRead ? readComparison() : undefined).finally(stopLoading);
    } else if (isSubmeterUtility || isSkipped) {
      // Under the loader as well: until the read lands a bill brought back is held (billDetailsForm.jsx), and nothing
      // typed in the meantime would survive the saved bill arriving. Opened this way from a skipped table's amounts.
      startLoading();
      readTable().then(markTableRead).finally(stopLoading);
    } else {
      markTableRead(true);
    }
    return () => {
      // A read for the cycle or utility being left says nothing about the one being opened.
      stopLoading();
      isCurrent = false;
    };
  }, [applyBill.status, billingCycleId, isOpen, propertyId, readAttempt, showPreview, utilityId]);
  useEffect(() => {
    var _property$allocations2, _utility$bill, _property$allocations3;
    // An allocation's own setting whenever the table has one; a draft's only for a table with none. On the allocation too:
    // a reload updates the utility in place, and one that brings another allocation -- after a removal here, allocated
    // again elsewhere (LB-6028) -- is shown with that allocation's setting, not one left from before.
    (_property$allocations2 = property.allocations) === null || _property$allocations2 === void 0 || _property$allocations2.setTempFileData('isShared', utility !== null && utility !== void 0 && (_utility$bill = utility.bill) !== null && _utility$bill !== void 0 && _utility$bill.id ? !!utility.bill.isShared : !!((_property$allocations3 = property.allocations) !== null && _property$allocations3 !== void 0 && (_property$allocations3 = _property$allocations3.tempFileData) !== null && _property$allocations3 !== void 0 && _property$allocations3.isShared));
  }, [utility, utility === null || utility === void 0 || (_utility$bill2 = utility.bill) === null || _utility$bill2 === void 0 ? void 0 : _utility$bill2.id]);

  // Once the statement is sent out there is nothing to edit on the bill side —
  // only the (read-only) meter details are relevant.
  const isStatementSent = applyBill.status === 'TableReadyStatementSent';
  const _useState9 = useState(isStatementSent ? 'meter' : 'bill'),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedTab = _useState0[0],
    setSelectedTab = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isMeterBusy = _useState10[0],
    setIsMeterBusy = _useState10[1];

  /**
   * Whether this cycle has saved meter rows to re-price, lifted here so it survives a Meter
   * details round trip instead of living in BillDetailsForm, which only fetched it once on mount.
   * Seeded once, below, from the same allocations lookup MeterDetails itself uses, when the cycle
   * opens: true while that lookup is pending (an unknown state over-warns rather than under-warns),
   * then set from the result. MeterDetails also confirms it true directly once a save succeeds.
   * Skipped once the statement is sent: the store wrapper cancels its previous in-flight run, so
   * this lookup would cancel MeterDetails' own fetch from the same commit and leave the read-only
   * grid empty, and without a Bill details tab there is nothing to read the value anyway.
   */
  const _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    hasSavedMeterRows = _useState12[0],
    setHasSavedMeterRows = _useState12[1];
  useEffect(() => {
    if (!isSubmeterUtility || isStatementSent || !propertyId || !utilityId || !billingCycleId) return undefined;
    setHasSavedMeterRows(true);
    let cancelled = false;
    store.allocations.getSubmeterBillingAllocationsAsync.run({
      propertyId,
      utilityId,
      billingCycleId
    }).then(resp => {
      if (cancelled) return;
      if (resp !== null && resp !== void 0 && resp.isSuccessful && Array.isArray(resp.response)) {
        setHasSavedMeterRows(resp.response.length > 0);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [isSubmeterUtility, isStatementSent, propertyId, utilityId, billingCycleId]);
  const readFailedAlert = /*#__PURE__*/React.createElement(Alert, {
    action: /*#__PURE__*/React.createElement(Button, {
      color: "inherit",
      onClick: () => setReadAttempt(attempt => attempt + 1),
      size: "small"
    }, "Retry"),
    severity: "error",
    size: "small"
  }, "We couldn't load this table's saved bill, so nothing is shown that could replace it. Retry to load it.");
  return /*#__PURE__*/React.createElement("div", {
    className: classes.modalData
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: currentCompany.billingTab.isModalLoading
  }), isSubmeterUtility && /*#__PURE__*/React.createElement("div", {
    className: classes.contentTabs
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: selectedTab,
    onChange: (_, v) => {
      track(events.tabNavigated(), {
        page,
        tab: v === 'meter' ? 'Meter details' : 'Bill details'
      });
      setSelectedTab(v);
    }
  }, !isStatementSent && /*#__PURE__*/React.createElement(Tab, {
    label: "Bill details",
    value: "bill",
    disabled: isMeterBusy
  }), /*#__PURE__*/React.createElement(Tab, {
    label: "Meter details",
    value: "meter"
  }))), hasReadFailed && isSubmeterUtility ? readFailedAlert : null, (!isSubmeterUtility || !isStatementSent) &&
  /*#__PURE__*/
  // display: contents while shown, so this wrapper doesn't itself sit in the box between
  // modalData and the title/body/footer it used to pin to the bottom; only display: none,
  // when hidden, needs the wrapper to actually be a box.
  React.createElement("div", {
    className: classes.billPane,
    style: isSubmeterUtility && selectedTab !== 'bill' ? {
      display: 'none'
    } : {
      display: 'contents'
    }
  }, showPreview && !isSubmeterUtility && !currentCompany.billingTab.isBillEdit ? null : /*#__PURE__*/React.createElement("div", {
    className: classes.formTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Bill details"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Enter your bill details to be able to charge your residents.")), hasReadFailed && !isSubmeterUtility ? readFailedAlert : null, isFormWithheld ? null : /*#__PURE__*/React.createElement(BillDetails, {
    handleClose: handleClose,
    property: property,
    showPreview: isSubmeterUtility ? false : showPreview,
    isSubmeterUtility: isSubmeterUtility,
    onSubmeterBillSaved: () => setSelectedTab('meter'),
    hasSavedMeterRows: hasSavedMeterRows,
    hasReadTable: hasReadTable
  })), isSubmeterUtility && selectedTab === 'meter' && /*#__PURE__*/React.createElement(MeterDetails, {
    propertyId: propertyId,
    utilityId: utilityId,
    billingCycleId: billingCycleId,
    billUsage: utility === null || utility === void 0 || (_utility$bill3 = utility.bill) === null || _utility$bill3 === void 0 ? void 0 : _utility$bill3.totalUsage,
    utility: utility,
    onRowsSaved: () => setHasSavedMeterRows(true),
    onNoRows: () => setHasSavedMeterRows(false),
    onBusy: setIsMeterBusy,
    onApproved: handleMeterApproved,
    servicePeriod: {
      endDateOnly: utility === null || utility === void 0 || (_utility$bill4 = utility.bill) === null || _utility$bill4 === void 0 ? void 0 : _utility$bill4.endDateOnly,
      startDateOnly: utility === null || utility === void 0 || (_utility$bill5 = utility.bill) === null || _utility$bill5 === void 0 ? void 0 : _utility$bill5.startDateOnly
    }
  }));
});